import React from 'react';
import useReveal from '../hooks/useReveal';
import './Certifications.css';

const registrations = [
  {
    icon: '🏛️',
    label: 'GST Registration',
    number: '36BTHPV6207M1Z2',
    desc: 'Registered under the Goods and Services Tax Act, Government of India.',
    badge: 'Govt. of India',
    badgeColor: 'blue',
    pdf: null,
  },
  {
    icon: '🍃',
    label: 'FSSAI License',
    number: 'See License Document',
    desc: 'Licensed by the Food Safety and Standards Authority of India for safe, hygienic food production.',
    badge: 'FSSAI',
    badgeColor: 'green',
    pdf: '/lab_reports/Fassai_License.pdf',
    pdfLabel: 'View FSSAI License',
  },
  {
    icon: '🏭',
    label: 'Udyam (MSME) Registration',
    number: 'See Registration Document',
    desc: 'Recognised as a Micro, Small & Medium Enterprise under the Ministry of MSME, Govt. of India.',
    badge: 'MSME',
    badgeColor: 'orange',
    pdf: '/lab_reports/Udyam_Registration.pdf',
    pdfLabel: 'View Udyam Certificate',
  },
];

export default function Certifications() {
  const ref = useReveal();

  return (
    <section className="cert-section" id="certifications" ref={ref}>
      {/* Decorative blobs */}
      <div className="cert-blob cert-blob-1" />
      <div className="cert-blob cert-blob-2" />

      {/* Header */}
      <div className="section-header reveal">
        <h2>Certifications &amp; Registrations</h2>
        <p>Transparency you can trust — every certification that validates our commitment to quality and compliance.</p>
      </div>

      {/* Registration cards */}
      <div className="cert-grid reveal">
        {registrations.map(({ icon, label, number, desc, badge, badgeColor, pdf, pdfLabel }) => (
          <div className="cert-card" key={label}>
            <div className="cert-card-top">
              <div className={`cert-icon-circle cert-icon-${badgeColor}`}>{icon}</div>
              <span className={`cert-badge cert-badge-${badgeColor}`}>{badge}</span>
            </div>
            <h3 className="cert-card-title">{label}</h3>
            <p className="cert-number">{number}</p>
            <p className="cert-desc">{desc}</p>
            {pdf && (
              <a
                href={pdf}
                target="_blank"
                rel="noopener noreferrer"
                className={`cert-pdf-btn cert-pdf-btn-${badgeColor}`}
              >
                <span className="cert-pdf-icon">📄</span>
                {pdfLabel}
              </a>
            )}
          </div>
        ))}
      </div>

      {/* Lab Reports — full-width highlight card */}
      <div className="cert-lab-wrap reveal">
        <div className="cert-lab-card">
          <div className="cert-lab-left">
            <div className="cert-lab-icon">🔬</div>
            <div>
              <h3>Independent Lab Reports</h3>
              <p>
                Our produce is regularly tested by accredited third-party laboratories.
                The reports confirm zero harmful chemical residues and full compliance
                with organic farming standards.
              </p>
            </div>
          </div>
          <a
            href="/lab_reports/Lab_Reports.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="cert-lab-btn"
          >
            <span>📥</span> Download Lab Reports
          </a>
        </div>
      </div>

      {/* Trust strip */}
      <div className="cert-trust-strip reveal">
        <span className="trust-item">✅ 100% Chemical Free</span>
        <span className="trust-divider" />
        <span className="trust-item">✅ FSSAI Certified</span>
        <span className="trust-divider" />
        <span className="trust-item">✅ GST Registered</span>
        <span className="trust-divider" />
        <span className="trust-item">✅ MSME Recognised</span>
      </div>
    </section>
  );
}
